import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {all, keys, set} from "@/shared/utils/idb.ts";

export const useHistoryStore = defineStore('history', () => {
  const history = ref<{ id: string; name: string }[]>([]);

  // add mutation function
  const addHistory = async (user: { id: string, name: string }) => {
    if (history.value.length > 0 && history.value.find((item) => item.id === user.id)) return;

    await set(user.id, user.name);
    history.value.push(user);
  };

  const clearHistory = () => {
    history.value = [];
  }

  const populateFromCache = async () => {
    const [keyss, values] = await Promise.all([keys(), all()]);
    history.value = keyss.map((key: IDBValidKey, index: number) => ({
      id: String(key),
      name: values[index],
    }));
  }

  const items = computed(() => history.value);

  return {
    items,
    addHistory,
    clearHistory,
    populateFromCache,
  };
});
